
import includes from 'lodash/includes';
import isArray from 'lodash/isArray';

import {
    initialState as loaderInitialState,
    createLoaderReducer
} from '../loader';

export const initialState = {
    ...loaderInitialState,
    permissions: null
};

export function getIsAdmin(state) {
    let isAdmin = null;
    let permissions = getPermissions(state);
    if (isArray(permissions)) {
        isAdmin = includes(permissions, 'ADMIN');
    }
    return isAdmin;
}

export function getIsPermissionsLoaded(state) {
    return (
        state.loaded &&
        !state.loading
    );
}

export function getPermissions(state) {
    return state.permissions;
}

function processPermissions(state, action) {
    return (action?.data?.data?.permissions)
        ? action?.data?.data?.permissions.map(item => item[0])
        : null;
}

export default function createReducer(actionType) {
    const loaderReducer = createLoaderReducer(actionType);

    return (state = initialState, action) => {
        switch (action.type) {

            case actionType.DEFAULT:
                return {
                    ...state
                };

            case actionType.SUCCESS:
                return {
                    ...state,
                    ...loaderReducer(state, action),
                    permissions: processPermissions(state, action)
                };

            default:
                return loaderReducer(state, action);
        }
    };
}
